import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCircleX } from "@fortawesome/pro-light-svg-icons";
import "./factorNodeEditMode.scss";
import { useAutoFocusElement } from "./useAutoFocusElement";

export interface IFactorPercentVariationValueType {
  valueType: "percent_variation";
  percentVariation: number;
}

interface IFactorNodePercentVariationEditModeProps {
  defaultPercentVariation: number;
  onConfirm: (value: IFactorPercentVariationValueType) => void;
  onCancel: () => void;
}

export function isFactorPercentVariationValid(percentVariation: number) {
  return percentVariation != null && percentVariation >= -100 && percentVariation <= 100 && percentVariation % 1 === 0;
}

export default function FactorNodePercentVariationEditMode(props: IFactorNodePercentVariationEditModeProps) {
  const { defaultPercentVariation, onConfirm, onCancel } = props;

  const autoFocusElementRef = useAutoFocusElement<HTMLInputElement>();

  const [percentVariationInput, setPercentVariationInput] = useState<string>(
    defaultPercentVariation == null ? "" : String(defaultPercentVariation),
  );

  const percentVariation = percentVariationInput === "" ? null : Number(percentVariationInput);

  return (
    <div className="factor-node-edit-mode">
      <div>
        <input
          ref={autoFocusElementRef}
          className="factor-node-edit-mode-input"
          value={percentVariationInput}
          onChange={e => setPercentVariationInput(e.target.value)}
        />
        %
      </div>
      <button
        type="button"
        className="factor-node-edit-mode-confirm"
        disabled={!isFactorPercentVariationValid(percentVariation)}
        onClick={() =>
          onConfirm({
            valueType: "percent_variation",
            percentVariation,
          })
        }
      >
        <FontAwesomeIcon icon={faCircleCheck} />
      </button>
      <button type="button" className="factor-node-edit-mode-cancel" onClick={onCancel}>
        <FontAwesomeIcon icon={faCircleX} />
      </button>
    </div>
  );
}
